export const teamSelect = [
  { name: "china", img: "/images/team/china.png" },
  { name: "usa", img: "/images/team/usa.png" },
  { name: "eu", img: "/images/team/eu.png" },
  { name: "russia", img: "/images/team/russia.png" },
  { name: "saudi", img: "/images/team/saudi.png" },
];
